import script from "./ConstructorActionsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorActionsItem.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorActionsItem.vue?vue&type=style&index=0&id=450e1bda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450e1bda"]])

export default __exports__